import React, { useContext, useState } from 'react'
import Table from 'components/common/Table'
import TableButton from 'components/common/Buttons/TableButton'
import { useNavigate } from 'react-router-dom'
import { MediatorContext } from 'context/MediatorContext'

const Dashboard = () => {
  const navigate = useNavigate()

  const { pendingRequests } = useContext(MediatorContext)

  const [selectedAccount, setSelectedAccount] = useState('')

  const ADITIONAL_COLUMNS = [
    {
      Header: 'Intérprete',
      accessor: ({ id, accountId, requestId }) => {
        const selectedAccountId = accountId || id
        const selectedRequestId = requestId || (accountId ? id : null)
        return (
          <TableButton
            color='primary'
            clickHandler={() => navigate(
              `/mediators/translators/${selectedAccountId}${selectedRequestId ? `?requestId=${selectedRequestId}` : ''}`,
            )}
          >
            Seleccionar intérprete
          </TableButton>
        )
      },
    },
    {
      Header: 'Llamadas',
      accessor: ({ id, firstName, lastName }) => (
        <TableButton
          clickHandler={() =>
            setSelectedAccount({
              endpoint: `mediators/accounts/${id}/calls`,
              title: `${firstName} ${lastName}`,
            })}
        >
          Ver Llamadas
        </TableButton>
      ),
    },
  ]
  return (
    <div className='flex flex-col gap-8'>
      <Table
        endpoint='mediators/pendingRequests'
        tableData={pendingRequests}
        aditionalColumns={ADITIONAL_COLUMNS}
        searchOptions={SEARCH_OPTIONS}
        orderOptions={ORDER_OPTIONS}
        disableAutoScroll
      />
      {selectedAccount && (
        <Table
          paginated
          endpoint={selectedAccount.endpoint}
          title={`Llamadas de ${selectedAccount.title}`}
        />
      )}
    </div>
  )
}

const SEARCH_OPTIONS = [
  'email',
  'firstName',
  'lastName',
  'speciality',
  'companyName',
]
const ORDER_OPTIONS = [
  'email',
  'firstName',
  'lastName',
  'speciality',
  'companyName',
]

export default Dashboard
